export default __webpack_public_path__ + "static/img5-c3836298e43eb297416c5b1d98b0d267.webp";